module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-10.a14cbb70.png";